import Person1 from "../../../images/reviews/person1.png";
import Person2 from "../../../images/reviews/person2.png";
import Person3 from "../../../images/reviews/person3.png";

const Reviews = [
  {
    stars: [1, 1, 1, 1, 1],
    name: "Lorem Ipsum",
    designation: "MVJ College of Engineering",
    imgUrl: Person1,
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur adipiscing elit dolor sit amet, consectetur adipiscing elit",
  },
  {
    stars: [1, 1, 1, 1, 1],
    name: "Lorem Ipsum",
    designation: "MVJ College of Engineering",
    imgUrl: Person2,
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit amet, consectetur adipiscing elit dolor sit amet, consectetur adipiscing elit",
  },
  {
    stars: [1, 1, 1, 1, 0],
    name: "Lorem Ipsum",
    designation: "MVJ College of Engineering",
    imgUrl: Person3,
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit",
  },
  {
    stars: [1, 1, 1, 1, 0],
    name: "Lorem Ipsum",
    designation: "MVJ College of Engineering",
    imgUrl: Person3,
    review:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit dolor sit amet, consectetur adipiscing elitLorem ipsum dolor sit",
  },
];

export default Reviews;
